import { render, staticRenderFns } from "./ModalRedeemSuccess.vue?vue&type=template&id=701605c4&scoped=true"
import script from "./ModalRedeemSuccess.vue?vue&type=script&lang=js"
export * from "./ModalRedeemSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeemSuccess.vue?vue&type=style&index=0&id=701605c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701605c4",
  null
  
)

export default component.exports